import { api } from "@/shared/api";
import type { TopicPage, TopicQuery, TopicThreadMessage } from "../model/topicTypes";

/**
 * C2 军师个人历史时间线 thin api。纯 backend 端点(非 ai 双层 envelope),`@/shared/api` 已解一层 ApiResponse.data,
 * 直接拿 payload(与 memoryApi 同,不二次解包)。scope 由后端从身份派生,前端不传 userId。
 */
export const advisorTopicsApi = {
  listTopics: (params: TopicQuery = {}) => {
    const q = new URLSearchParams({
      page: String(params.page ?? 1),
      size: String(params.size ?? 10),
    });
    if (params.query && params.query.trim()) q.set("query", params.query.trim());
    if (params.from) q.set("from", params.from);
    if (params.to) q.set("to", params.to);
    return api.get<TopicPage>(`/advisor/topics?${q}`);
  },
  topicThread: (topicId: string) =>
    api.get<TopicThreadMessage[]>(`/advisor/topics/${encodeURIComponent(topicId)}/thread`),
};
